import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { withApollo, compose } from 'react-apollo'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import {
  getHeroBankById,
  fetchBankList
} from '../../../../modules/heroGroupSelling'
import {
  Card,
  Table,
  Button,
  Input,
  Icon,
  Avatar
} from 'antd'
import { isEmpty } from 'lodash'
import { useDeepEffect } from '../../../../utils/hooks'
import _ from 'lodash'
import Highlighter from 'react-highlight-words'

const HeroBankAccount = ({ data }) => {
  const dispatch = useDispatch()
  let searchInput = useRef(null)
  const [searchText, setSearchText] = useState('')

  const { herobank, bankList, isLoading } = useSelector(
    (state) => ({
      herobank: state.heroGroupSelling.herobank,
      bankList: state.heroGroupSelling.bankList,
      isLoading: state.heroGroupSelling.isLoading
    }),
    []
  )
  useDeepEffect(() => {
    async function fetch() {
      await dispatch(getHeroBankById(data.id))
      await dispatch(fetchBankList())
    }

    fetch()
  }, [])

  console.log(herobank)

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}>
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select())
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  })

  const handleSearch = (selectedKeys, confirm) => {
    confirm()
    setSearchText(selectedKeys[0])
  }

  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }

  const GetDate = (created) => {
    let date = ''
    if (created !== null) {
      date = moment(created).add(543, 'years').format('DD/MM/YYYY HH:mm')
    }
    return date
  }

  const refetchData = async () => { }

  const columns = [
    {
      title: 'ธนาคาร',
      dataIndex: 'bankName',
      key: 'bankName',
      filters: bankList.map((bank) => ({
        text: bank.bankName,
        value: bank.bankName
      })),
      onFilter: (value, record) => record.bankName === value,
      render: (name, row) => (
        <div>
          <Avatar src={row.bankLogo} alt="" size={64} />
          &nbsp;&nbsp;
          {name}
        </div>
      )
    },
    {
      title: 'เลขบัญชี',
      dataIndex: 'bankAccount',
      key: 'bankAccount',
    },
    {
      title: 'ชื่อฮีโร่',
      dataIndex: 'hero.name',
      key: 'heroname',
      ...getColumnSearchProps('name'),
      sorter: (a, b) => a.hero.name.length - b.hero.name.length,
      render: (name, row) => (
        <div>
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={name.toString()}
          />
        </div>
      )
    },
    {
      title: 'วันที่เพิ่มข้อมูล',
      dataIndex: 'createdAt',
      key: 'createdAt',
      sorter: (a, b) => a.createdAt - b.createdAt,
      render: (createdAt) => {
        const created = GetDate(createdAt)
        return (
          <span>
            {created}
          </span>
        )
      }
    },
    {
      title: 'วันที่อัพเดทข้อมูล',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      render: (updatedAt) => {
        const update = GetDate(updatedAt)
        return (
          <span>
            {update}
          </span>
        )
      }
    },
  ]

  return (
    <Card
      title="Hero Bank Account"
      extra={
        <div>
          <Button size="small" icon="reload" onClick={() => refetchData()}>
            Reload
          </Button>
        </div>
      }>
      {!isEmpty(herobank) ?
        <Table
          loading={isLoading}
          scroll={{ x: 1000 }}
          rowKey={(record) => record.id}
          dataSource={herobank}
          columns={columns}
        />
        : "ไม่มีบัญชีธนาคาร"}
    </Card>
  )
}

export default compose(
  withApollo
)(HeroBankAccount)
